<!-- 控销-商品管理 -->
<template>
  <div class="classification">
    <div class="header">
      <el-form ref="formTool"
               :model="formTool"
               :inline="true"
               style="text-align: left;display: flex;">
        <el-form-item prop="id"
                      style="margin: 0px !important;display: flex;"
                      label="">
          <el-input v-model="formTool.keyWord"
                    placeholder="一审、二审手机号/一审、二审姓名"
                    clearable
                    size="small"
                      style=" width:300px"
                    />
        </el-form-item>
        <el-form-item prop="id"
                      style="margin-left: 16px !important;display: flex;"
                      label="">
          <el-date-picker v-model="date"
                          size="small"
                          value-format="yyyy-MM-dd"
                          type="daterange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <el-button size="small"
                 style="margin-left: 16px;"
                 type="primary"
                 @click="getList(1,'48')">查询</el-button>
      <el-button size="small"
      style="margin-left: 16px;"
      type="plain"
      @click="exprot(1,'48')">导出</el-button>          
    </div>

    <div class="center"
         style="position: relative">
      <MyTable :table-data="tableData"
               :index="index"
               :selection="selection"
               :operation="operation"
               :table-option.sync="tableOption"
               @handleSelectionChange="handleSelectionChange">
        <template slot="second_status"
                  slot-scope="scope">
          <span>
            {{ getStatus(scope.row.second_status) }}
          </span>
        </template>
      </MyTable>
      <div style="display: flex;justify-content: flex-end;padding: 5px 0;">
        <el-pagination :current-page="page.current"
                       :page-size="page.size"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :page-sizes="[10, 20, 30, 50]"
                       layout="total, sizes, prev, pager, next"
                       :total="page.total">
        </el-pagination>
      </div>

    </div>

  </div>
</template>

<script>
import dayjs from 'dayjs'
import MyTable from "@/components/myTable";
import _ from 'lodash'
import { mapGetters } from 'vuex'
import { queryGoodsSalesEcharts ,excelExport} from "@/api/statistics";

import avater from "/public/img/default.png";

export default {
  components: {
    MyTable,

  },
  data () {
    return {
      date: [dayjs().format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')],
      avater: avater,
      formTool: {
        keyWord: ''
      },
      btnType: 'add',
      selectionList: [],
      operation: false,
      selection: false,
      index: false,
      tableData: [{ id: 1 }],
      tableOption: [
        { label: "商品名称", prop: "goods_name", width: '160px' },
        { label: "基库ID", prop: "goods_id", width: '200px' },
        { label: "一审手机号", prop: "first_username", width: '140px' },
        { label: "一审时间", prop: "first_audit_time", width: '200px' },
        { label: "一审姓名", prop: "first_full_name" },
        { label: "二审状态", prop: "second_status" },
        { label: "二审手机号", prop: "second_username" },
        { label: "二审时间", prop: "second_audit_time", width: '200px' },
        { label: "二审姓名", prop: "second_full_name" },
        // { label: "发布用户名", prop: "createBy"  },
        // { label: "发布时间", prop: "createTime" },
      ],
      page: {
        total: 0,
        current: 1,
        size: 10,
        pageSizes: [10, 20, 30, 50],
      },
    };
  },
  computed: {},
  watch: {},
  created () {
  },

  mounted () {
    this.getList(1, '48');
  },
  beforeCreate () { },
  beforeMount () { },
  beforeUpdate () { },
  updated () { },
  beforeDestroy () { },
  destroyed () { },
  activated () { },
  computed: {
    ...mapGetters(['permissions']),
  },
  methods: {
    // 查询状态
    getStatus (status) {
      switch (status) {
        case 'SOLDOUT':
          return '下架'
          break;
        case 'AWAIT':
          return '待审核'
          break;
        case 'ALREADY':
          return '已审核'
          break;
        case 'FAIL':
          return '审核失败'
          break;
        case 'PERFECT':
          return '已完善待审'
          break;
        default:
          return ''
          break;
      }
    },
    didSelectItem (row) {
      // 选择商品
      this.$refs['goods-setting-dailog'].init(row, 'add')
    },
    // 页码变化
    handleCurrentChange (e) {
      this.page.current = e
      this.getList(e, '48')
    },
    // 条数变化
    handleSizeChange (e) {
      this.page.size = e
      this.page.current = 1;
      this.getList(1, '48')
    },

    detailHandle (row, btnType) {
      if (btnType == 'delete') {
        this.openMessageBox(row)
      }

      if (btnType == 'add') {
        this.$refs['goods-dailog'].init(row, btnType)
      }

      if (btnType == 'detail') {
        this.$refs['goods-setting-dailog'].init(row, btnType)
      }
    },
    openMessageBox (data) {
      this.$confirm("确定要删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.removeRecall(data);
        })
        .catch(() => { });
    },
    // removeRecall (row) {
    //   messageRecallDelete({ id: row.id }).then((res) => {
    //     if (res) {
    //       this.$message.success('删除成功!')
    //       this.getList();
    //     }
    //   });
    // },

    // 重置查询条件
    reset () {
      this.formTool = {

      };
      this.getList(1);
    },
    exprot(current, type){
      if (!this.date) {
        this.$message.warning('请先选择时间')
        return
      }
      let start = this.date && this.date.length > 0 ? this.date[0] : ''
      let end = this.date && this.date.length > 0 ? this.date[1] : ''
      console.log(this.page, 'page')
      
      let param = {}
      param = {
          type: 49,
          params: [start, end, this.formTool.keyWord, this.formTool.keyWord, this.formTool.keyWord, this.formTool.keyWord, this.formTool.keyWord, this.formTool.keyWord, this.formTool.keyWord, this.formTool.keyWord]
        }
      excelExport(param).then((res) => {
    
      });
    },
    // 勾选
    handleSelectionChange (val) {
      this.selectionList = val;
    },
    // 查询  列表
    getList (current, type) {
      if (!this.date) {
        this.$message.warning('请先选择时间')
        return
      }
      let start = this.date && this.date.length > 0 ? this.date[0] : ''
      let end = this.date && this.date.length > 0 ? this.date[1] : ''
      console.log(this.page, 'page')
      if (current) {
        // 搜索条件改变从第一页开始查询
        this.page.current = current;
      }
      let param = {}
      if (type == '47') {
        param = {
          type: type,
          params: [start, end, this.formTool.keyWord, this.formTool.keyWord, this.formTool.keyWord, this.formTool.keyWord, this.formTool.keyWord, this.formTool.keyWord, this.formTool.keyWord, this.formTool.keyWord, this.page.size, (this.page.size * (this.page.current - 1))]
        };
      } else {
        param = {
          type: type,
          params: [start, end, this.formTool.keyWord, this.formTool.keyWord, this.formTool.keyWord, this.formTool.keyWord, this.formTool.keyWord, this.formTool.keyWord, this.formTool.keyWord, this.formTool.keyWord]
        }
      }
      queryGoodsSalesEcharts(param).then((res) => {
        if (type == '47') {
          this.tableData = res;
        } else {
          try {
            this.page.total = Number(res[0].cnt)
            this.getList(this.page.current, '47')
          } catch (error) {
            this.$message.warning('查询总数出错，请联系管理员')
          }
        }
      });
    },
  },
};
</script>
<style lang='scss' scoped>
@import "@/styles/variables.scss";

.classification {
  padding: 0px;

  .header {
    height: 56px;
    display: flex;
    align-items: center;
    // justify-content: space-between;
    padding: 0px 24px 0px 24px !important;
    border-bottom: 1px solid #f5f5f5;

    .font {
      font-size: 16px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 600;
      text-align: left;
      color: #262626;
    }

    .el-form-item {
      margin: 0px 0px 0px 8px !important;
    }
  }

  background: white;

  .top {
    display: flex;
    padding: 10px 0 10px 0;

    .item {
      display: flex;
      align-items: center;
      margin-right: 20px;

      .label {
        width: 120px;
      }

      .button {
        margin-right: 20px;

        ::v-deep .el-button {
          color: $subMenuActiveText;
          background-color: $butColor;
          border-color: $butColor;

          &:hover {
            color: $subMenuActiveText;
            background-color: $butColor;
            border-color: $butColor;
          }

          &:active {
            color: $subMenuActiveText;
            background: $butColor;
            background-color: $butColor;
            border-color: $butColor;
          }

          &:focus {
            color: $subMenuActiveText;
            background-color: $butColor;
            border-color: $butColor;
          }
        }
      }
    }
  }

  .center {
    margin-top: 16px;
    padding: 0 24px;
    height: calc(100% - 131px);

    .shangjia {
      position: absolute;
      z-index: 2;
      bottom: -45px;
    }
  }

  .btn-warp {
    display: flex;
    justify-content: space-around;

    .el-link {
      // margin: 5px;
    }
  }
}
</style>
